<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Sticky Header Container -->
    <div class="sticky top-0 z-20">
      <!-- Top Bar -->
      <div class="bg-gray-900 text-white py-2 text-sm">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex justify-between items-center">
            <!-- Left Contact Info -->
            <div class="flex items-center space-x-6">
              <div class="flex items-center">
                <svg class="w-4 h-4 mr-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                <span class="text-gray-300">LINE: @ecobzthai</span>
              </div>
            </div>
            
            <!-- Right Contact Info -->
            <div class="flex items-center space-x-6">
              <div class="hidden md:flex items-center">
                <svg class="w-4 h-4 mr-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
                <span class="text-gray-300">titaphon@ecobz.org</span>
              </div>
              <!-- <div class="flex items-center space-x-3">
                <a href="#" class="text-gray-300 hover:text-white transition-colors">
                  <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                  </svg>
                </a>
                <a href="#" class="text-gray-300 hover:text-white transition-colors">
                  <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a href="#" class="text-gray-300 hover:text-white transition-colors">
                  <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
                  </svg>
                </a>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- Header Navigation -->
      <nav class="bg-white shadow-sm border-b border-gray-100">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-16">
          <!-- Logo -->
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <img 
                src="https://vue-project.sgp1.digitaloceanspaces.com/2025/08/1755255121882.png" 
                alt="โลโก้ EcobzKM" 
                class="mx-auto h-12 md:h-12 w-auto mb-0"
              >
            </div>
          </div>
          
          <!-- Navigation Menu -->
          <div class="hidden md:block">
            <div class="ml-6 flex items-center space-x-6">
              <a
                v-for="item in navItems"
                :key="item.id"
                :href="`#${item.id}`"
                @click.prevent="smoothScrollTo(item.id)"
                :class="[
                  'px-3 py-2 text-sm font-medium transition-colors',
                  isActiveMenuItem(item.id)
                    ? 'text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-700 hover:text-blue-600'
                ]"
              >
                {{ item.label }}
              </a>
              <button @click="openSchedule('trial', { source: 'header-desktop' })" class="bg-blue-600 text-white px-3 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors">
                ทดลองใช้ฟรี
              </button>
            </div>
          </div>
          
          <!-- Mobile menu button -->
          <div class="md:hidden">
            <button @click="mobileMenuOpen = !mobileMenuOpen" class="text-gray-700 hover:text-blue-600">
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
        
        <!-- Mobile Navigation Menu -->
        <div v-show="mobileMenuOpen" class="md:hidden bg-white border-t border-gray-200">
          <div class="px-2 pt-2 pb-3 space-y-1">
            <a
              v-for="item in navItemsMobile"
              :key="item.id"
              :href="`#${item.id}`"
              @click.prevent="scrollToMobile(item.id)"
              :class="[
                'block px-3 py-2 text-base font-medium transition-colors',
                isActiveMenuItem(item.id)
                  ? 'text-blue-600 bg-blue-50 border-l-4 border-blue-600'
                  : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
              ]"
            >
              {{ item.label }}
            </a>
            <button @click="openSchedule('trial', { source: 'header-mobile' })" class="w-full text-left bg-blue-300 text-white px-3 py-2 rounded-lg text-base font-medium hover:bg-blue-700 transition-colors mt-2">
              ทดลองใช้ฟรี
            </button>
          </div>
        </div>
      </div>
    </nav>
    </div>

    <!-- Main Content -->
    <main>
      
      <section id="hero">
        <Hero/>
      </section>
      <section id="point">
        <Point/>
      </section>
      <section id="feature">
        <Feature/>
      </section>
      <section id="security">
        <Security/>
      </section>
      <section id="reference">
        <Reference/>
      </section>
      <section id="package">
        <Package/>
      </section>
      <section id="about">
        <About/>
      </section>
      <section id="service">
        <Service/>
      </section>
      <!-- <section id="client">
        <Client/>
      </section> -->

      <!-- Call to Action -->
      <section class="py-16 bg-blue-600">
        <div class="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 class="text-3xl font-bold text-white mb-4">พร้อมสร้าง KM ของคุณแล้วหรือยัง?</h2>
          <p class="text-xl text-blue-100 mb-8">ร่วมเปลี่ยนวิธีบริหารองค์ความรู้ด้วย EcobzKM</p>
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <button @click="openSchedule('trial', { source: 'cta-section' })" class="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
              เริ่มทดลองใช้ฟรี
            </button>
            <button @click="openSchedule('demo', { source: 'cta-section' })" class="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors">
              นัดหมายเดโม่
            </button>
          </div>
          <p class="text-sm text-blue-200 mt-4">ติดตั้งภายใน 24 ชั่วโมง • การสนับสนุน 24/7</p>
        </div>
      </section>
    </main>

    <!-- Footer -->
    <footer class="bg-gray-900 text-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div class="grid md:grid-cols-4 gap-8">
          <!-- Company Info -->
          <div>
            <h3 class="text-2xl font-bold text-blue-400 mb-4">EcobzKM</h3>
            <p class="text-gray-300 mb-4">บริษัท Ecobz เป็น Digital Provider Technology ที่มุ่งเน้นการนำเสนอโซลูชันดิจิทัลแบบครบวงจรสำหรับโรงงานในภาคอุตสาหกรรม เราครอบคลุมทุกด้าน</p>
            <div class="flex space-x-4">
              <!-- <a href="#" class="text-gray-400 hover:text-white transition-colors">
                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                </svg>
              </a>
              <a href="#" class="text-gray-400 hover:text-white transition-colors">
                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
                </svg>
              </a>
              <a href="#" class="text-gray-400 hover:text-white transition-colors">
                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a> -->
            </div>
          </div>

          <!-- Quick Links -->
          <div>
            <h4 class="text-lg font-semibold mb-4">ผลิตภัณฑ์</h4>
            <ul class="space-y-2">
              <!-- <li><a href="#" class="text-gray-300 hover:text-white transition-colors">KM SaaS Platform</a></li> -->
              <li><a href="#" class="text-gray-300 hover:text-white transition-colors">เอกสาร API</a></li>
              <li><a href="#" class="text-gray-300 hover:text-white transition-colors">โซลูชัน White Label</a></li>
              <li><a href="#" class="text-gray-300 hover:text-white transition-colors">Custom Development</a></li>
              <li><a href="#" class="text-gray-300 hover:text-white transition-colors">ราคา</a></li>
            </ul>
          </div>

          <!-- Support -->
          <div>
            <h4 class="text-lg font-semibold mb-4">ช่วยเหลือ & สนับสนุน</h4>
            <ul class="space-y-2">
              <li><a href="#" class="text-gray-300 hover:text-white transition-colors">เริ่มต้นใช้งาน</a></li>
              <li><a href="#" class="text-gray-300 hover:text-white transition-colors">คู่มือ Developer</a></li>
              <li><a href="#" class="text-gray-300 hover:text-white transition-colors">สถานะระบบ</a></li>
              <!-- <li><a href="#" class="text-gray-300 hover:text-white transition-colors">ความปลอดภัย</a></li> -->
              <li><a href="#" class="text-gray-300 hover:text-white transition-colors">ติดต่อทีมสนับสนุน</a></li>
            </ul>
          </div>

          <!-- Contact -->
          <div>
            <h4 class="text-lg font-semibold mb-4">ติดต่อเรา</h4>
            <div class="space-y-2 text-gray-300">
              <p class="flex items-center">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                LINE: @ecobzthai
              </p>
              <p class="flex items-center">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                titaphon@ecobz.org

              </p>
              <p class="flex items-start">
                <svg class="w-5 h-5 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                76/64 Changwattana Road, Anusawaree, Bangkean, Bangkok 10220, Bangkok, Bangkok
              </p>
            </div>
          </div>
        </div>

        <!-- Bottom Bar -->
        <div class="border-t border-gray-800 mt-8 pt-8 text-center">
          <p class="text-gray-400">© 2025 EcobzKM. All rights reserved. สร้างเพื่ออนาคตของระบบจัดการความรู้</p>
        </div>
      </div>
    </footer>

  <!-- Global Schedule Modal -->
  <GlobalScheduleModal />

  <!-- Content slot for child pages -->
    <slot />

    <!-- Scroll to Top Button -->
    <button 
      v-show="showScrollTop" 
      @click="scrollToTop"
      class="fixed bottom-8 right-8 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg transition-all duration-300 z-40"
    >
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"/>
      </svg>
    </button>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick, computed } from 'vue'
import Hero from '~/layouts/theme/custom/module/Hero.vue';
import Point from '~/layouts/theme/custom/module/Point.vue';
import Feature from '~/layouts/theme/custom/module/Feature.vue';
import Security from '~/layouts/theme/custom/module/Security.vue';
import Reference from '~/layouts/theme/custom/module/Reference.vue';
import Package from '~/layouts/theme/custom/module/Package.vue';
import About from '~/layouts/theme/custom/module/About.vue';
import Client from '~/layouts/theme/custom/module/Client.vue';
import Service from '~/layouts/theme/custom/module/Service.vue';
import GlobalScheduleModal from '~/components/GlobalScheduleModal.vue'
import { useScheduleModal } from '~/composables/useScheduleModal'

const { openSchedule } = useScheduleModal()

// Scroll to top functionality
const showScrollTop = ref(false)
const mobileMenuOpen = ref(false)
const activeSection = ref('hero') // Track active section

// Navigation items (desktop)
const navItems = ref([
  { id: 'feature', label: 'ฟีเจอร์' },
  { id: 'reference', label: 'ผลงาน' },
  { id: 'package', label: 'แพ็กเกจ' },
  { id: 'about', label: 'เกี่ยวกับเรา' },
  { id: 'service', label: 'บริการอื่น ๆ' },
])

// Navigation items (mobile) - include Home at the top
const navItemsMobile = computed(() => [
  { id: 'hero', label: 'หน้าแรก' },
  ...navItems.value,
])

const handleScroll = () => {
  showScrollTop.value = window.scrollY > 300
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

// Mobile scroll function that closes menu
const scrollToMobile = (elementId) => {
  mobileMenuOpen.value = false
  smoothScrollTo(elementId)
}

// Smooth scroll for navigation links
const smoothScrollTo = (elementId) => {
  console.log('Attempting to scroll to:', elementId)
  const element = document.getElementById(elementId)
  if (element) {
    const headerHeight = 120 // Account for sticky header height
    const elementTop = element.getBoundingClientRect().top + window.pageYOffset
    const offsetTop = elementTop - headerHeight
    console.log('Element found, scrolling to offset:', offsetTop)
    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth'
    })
  } else {
    console.error('Element not found with ID:', elementId)
    // List all available IDs for debugging
    const allElements = document.querySelectorAll('[id]')
    console.log('Available IDs:', Array.from(allElements).map(el => el.id))
  }
}

// Setup intersection observer for active section tracking
const setupIntersectionObserver = () => {
  const sections = ['hero', 'point', 'feature', 'security', 'reference', 'package', 'about', 'service', 'client']
  
  const observerOptions = {
    root: null,
    rootMargin: '-120px 0px -50% 0px', // Account for sticky header and trigger when section is in middle
    threshold: 0
  }
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        activeSection.value = entry.target.id
        console.log('Active section changed to:', entry.target.id)
      }
    })
  }, observerOptions)
  
  // Observe all sections
  sections.forEach(sectionId => {
    const element = document.getElementById(sectionId)
    if (element) {
      observer.observe(element)
    }
  })
  
  return observer
}

// Check if menu item is active
const isActiveMenuItem = (sectionId) => {
  return activeSection.value === sectionId
}

onMounted(() => {
  nextTick(() => {
    window.addEventListener('scroll', handleScroll)
    
    // Setup intersection observer for active section tracking
    const observer = setupIntersectionObserver()
    
    // Add click handlers for navigation links using a more specific approach
    const setupNavigation = () => {
      const navLinks = document.querySelectorAll('nav a[href^="#"]')
      console.log('Found nav links:', navLinks.length) // Debug log
      
      navLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          const href = link.getAttribute('href')
          const targetId = href ? href.substring(1) : ''
          console.log('Clicked link:', href, 'Target ID:', targetId) // Debug log
          if (targetId) {
            smoothScrollTo(targetId)
          }
        })
      })
    }
    
    // Setup navigation after a short delay to ensure DOM is ready
    setTimeout(setupNavigation, 100)
    
    // Store observer for cleanup
    window.sectionObserver = observer
  })
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  
  // Cleanup intersection observer
  if (window.sectionObserver) {
    window.sectionObserver.disconnect()
    delete window.sectionObserver
  }
})

// Expose scrollTo function globally for manual testing
if (process.client) {
  window.scrollToSection = smoothScrollTo
}
</script>

<style scoped>
/* Smooth scrolling */
html {
  scroll-behavior: smooth;
}

/* Basic glass morphism effect */
.backdrop-blur-md {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

/* Scroll to top button animation */
.scroll-to-top-enter-active,
.scroll-to-top-leave-active {
  transition: all 0.3s ease;
}

.scroll-to-top-enter-from,
.scroll-to-top-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>